// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import supabase from '../../../../../utility/Supabase'
import { getUserData, handleError, handleSuccess } from '../../../../../utility/Utils'

export const getAllTransactions = createAsyncThunk('IMSTransactions/getAllTransactions', async (params) => {
	const { data, error } = await supabase.from('transactions').select(`*, org (name), proj (name), state (id, state), user (*, role (role), status (status))`, { count: 'exact' })
	if (error) {
		handleError(error.message)
	}
	return data
})

export const setMaterialDetails = createAsyncThunk('IMSTransactions/getMaterialDetails', async (params, { dispatch, getState }) => {
	// const response = await supabase.from('materials').select(`*, status (status)`).filter('id', 'eq', params.id)
	// console.log(response.data[0])
	// return response.data[0]
	return params
})

// export const getTransactionDetails = createAsyncThunk('IMSTransactions/getTransactionDetails', async (transactions, { dispatch, getState }) => {
// 	const newTransactions = transactions.map((txn) => {
// 		const newDetails = txn.details.map((param, index) => {
// 			const materialDetails = getState().transactions.materials[param.id]
// 			console.log(materialDetails)
// 			if (materialDetails) {
// 				const newMaterialDetails = {
// 					...materialDetails,
// 					...param
// 				}
// 				return newMaterialDetails
// 			} else {
// 				dispatch(getMaterialDetails(param))
// 			}
// 		})
// 		return {
// 			...txn,
// 			details: newDetails
// 		}
// 	})
// 	console.log(newTransactions)
// 	return newTransactions
// })

export const getTransactions = createAsyncThunk('IMSTransactions/getTransaction', async (params, { dispatch, getState }) => {
	const currentUser = Object.keys(getState().auth.userData).length ? getState().auth.userData : getUserData()
	// console.log(params)
	const { q, sortOrder, sortColumn, status, user, page, perPage, org, proj, manager } = params
	// console.log(['asc', '', undefined].includes(sortOrder))
	const startRange = (page - 1) * perPage
	const endRange = startRange + perPage - 1
	// console.log(startRange)
	// console.log(endRange)

	let sql_query = supabase.from('transactions').select(`*, org (name), proj (name), state (id, state), user (*, role (role), status (status))`, { count: 'exact' })

	// if (q && q !== '') {
	// 	sql_query = sql_query.or(`f_name.ilike.%${q}%,l_name.ilike.%${q}%`)
	// 	// sql_query = sql_query.ilike('f_name', `%${q}%`).ilike('l_name', `%${q}%`)
	// }
	if (status && status !== '') {
		sql_query = sql_query.filter('state', 'eq', parseInt(status))
	}
	if (user && user !== '') {
		sql_query = sql_query.filter('user', 'eq', user)
	}
	if (org && org !== '') {
		sql_query = sql_query.filter('org', 'eq', org)
	}
	// if (proj && proj !== '') {
	// 	sql_query = sql_query.filter('proj', 'eq', parseInt(proj))
	// }
	if (!currentUser.acl.is_super_admin && !currentUser.proj) {
		sql_query.in('proj', currentUser.projAccess)
	} else if (!currentUser.proj) {
		sql_query.eq('org', currentUser.org.id)
	}
	if (proj && proj !== '') {
		sql_query = sql_query.filter('proj', 'eq', proj)
	}
	// if (manager && manager !== '') {
	// 	sql_query = sql_query.filter('manager', 'eq', manager)
	// }
	if (sortColumn && sortColumn !== '') {
		sql_query = sql_query.order(sortColumn, { ascending: ['asc', '', undefined].includes(sortOrder) })
	} else {
		sql_query = sql_query.order('id', { ascending: false })
	}
	if (startRange !== undefined && endRange !== undefined) {
		sql_query = sql_query.range(startRange, endRange)
	}

	// sql_query = sql_query
	// console.log(sql_query)
	let dispatchCount = 0
	let memoCount = 0
	const memo = {}
	const { data: transactions, error, count } = await sql_query
	if (error) {
		handleError(error.message)
	}
	const newTransactions = []
	for (const txn of transactions) {
		const newDetails = []
		for (const detail of txn.details) {
			// console.log(memo[detail.id], getState())
			const materialDetails = memo[detail.id] || getState().transactions.materials[detail.id] || getState().materialTransfer.materials[detail.id]
			// console.log(materialDetails)
			if (materialDetails) {
				const newMaterialDetails = {
					...materialDetails,
					...detail
				}
				newDetails.push(newMaterialDetails)
				// console.log(newDetails)
				memoCount += 1
				// console.log(`Memo used: ${memoCount}`)
			} else {
				const response = await supabase.from('materials').select(`*, status (status)`).filter('id', 'eq', detail.id)
				// console.log(response)
				memo[detail.id] = response.data[0]
				dispatch(setMaterialDetails(response.data[0]))
				const newMaterialDetails = {
					...response.data[0],
					...detail
				}
				newDetails.push(newMaterialDetails)
				dispatchCount += 1
				// console.log(`Dispatch used: ${dispatchCount}`)
			}
			// console.log(detail)
			// console.log(newDetails)
		}
		newTransactions.push({
			...txn,
			details: newDetails
		})
		// console.log(newTransactions)
	}

	return {
		params,
		data: newTransactions || [],
		totalPages: Math.ceil(count / params.perPage) || 0
	}
})

export const getSingleTransaction = createAsyncThunk('IMSTransactions/getSingleTransaction', async (params, { dispatch, getState }) => {
	const currentUser = Object.keys(getState().auth.userData).length ? getState().auth.userData : getUserData()
	const existingData = getState().transactions.data
	existingData.forEach(async (txn) => {
		if (txn.id === params.id) {
			console.log('Update found')
			// dispatch(getSingleTransaction({ id: payload.old.id }))
			const txnQuery = supabase.from('transactions').select(`*, org (name), proj (name), state (id, state), user (*, role (role), status (status))`).filter('id', 'eq', params.id)
			if (!currentUser.acl.is_super_admin && !currentUser.proj) {
				// txnQuery.in('from', currentUser.projAccess)
				txnQuery.or(`from.in.${currentUser.projAccess}, to.in.${currentUser.projAccess}`)
			} else if (!currentUser.proj) {
				txnQuery.eq('org', currentUser.org.id)
			}
			const response = await txnQuery
			const newTransactions = getState().transactions.data.map((txn) => {
				if (txn.id === params.id) {
					return response.data[0]
				} else {
					return txn
				}
			})
			return newTransactions
		}
	})
	return existingData
})

export const getTransactionCounts = createAsyncThunk('IMSTransactions/getCounts', async (params, { dispatch, getState }) => {
	const currentUser = Object.keys(getState().auth.userData).length ? getState().auth.userData : getUserData()
	const totalQuery = supabase.from('transactions').select('*', { count: 'exact', head: true })
	const awaitingApprovalQuery = supabase.from('transactions').select('*', { count: 'exact', head: true }).eq('state', 1)
	const approvedQuery = supabase.from('transactions').select('*', { count: 'exact', head: true }).eq('state', 2)
	const rejectedQuery = supabase.from('transactions').select('*', { count: 'exact', head: true }).eq('state', 3)
	const deliveredQuery = supabase.from('transactions').select('*', { count: 'exact', head: true }).eq('state', 4)
	const confirmedQuery = supabase.from('transactions').select('*', { count: 'exact', head: true }).eq('state', 5)
	const closedQuery = supabase.from('transactions').select('*', { count: 'exact', head: true }).eq('state', 6)
	// const deactivatedQuery = supabase.from('transactions').select('*', { count: 'exact', head: true }).eq('state', 7)
	const deletedQuery = supabase.from('transactions').select('*', { count: 'exact', head: true }).eq('state', 8)

	if (!currentUser.acl.is_super_admin && !currentUser.proj) {
		console.log('Not super admin')
		totalQuery.in('proj', currentUser.projAccess)
		awaitingApprovalQuery.in('proj', currentUser.projAccess)
		approvedQuery.in('proj', currentUser.projAccess)
		rejectedQuery.in('proj', currentUser.projAccess)
		deliveredQuery.in('proj', currentUser.projAccess)
		confirmedQuery.in('proj', currentUser.projAccess)
		closedQuery.in('proj', currentUser.projAccess)
		// approvedQuery.in('proj', currentUser.projAccess)
		deletedQuery.in('proj', currentUser.projAccess)
	} else if (!currentUser.proj) {
		console.log('Not super admin')
		totalQuery.eq('org', currentUser.org.id)
		awaitingApprovalQuery.eq('org', currentUser.org.id)
		approvedQuery.eq('org', currentUser.org.id)
		rejectedQuery.eq('org', currentUser.org.id)
		deliveredQuery.eq('org', currentUser.org.id)
		confirmedQuery.eq('org', currentUser.org.id)
		closedQuery.eq('org', currentUser.org.id)
		// approvedQuery.eq('org', currentUser.org.id)
		deletedQuery.eq('org', currentUser.org.id)
	}
	const { count: total, error: totalError } = await totalQuery
	const { count: awaitingApproval, error: awaitingApprovalError } = await awaitingApprovalQuery
	const { count: approved, error: approvedError } = await approvedQuery
	const { count: rejected, error: rejectedError } = await rejectedQuery
	const { count: delivered, error: deliveredError } = await deliveredQuery
	const { count: confirmed, error: confirmedError } = confirmedQuery
	const { count: closed, error: closedError } = await closedQuery
	const { count: deleted, error: deletedError } = await deletedQuery
	// console.log({ totalError, awaitingApprovalError, approvedError, rejectedError, deliveredError, closedError })
	if (totalError || awaitingApprovalError || approvedError || rejectedError || deliveredError || closedError) {
		// prettier-ignore
		[totalError, awaitingApprovalError, approvedError, rejectedError, deliveredError, closedError].forEach((error) => {
			if (error) {
				handleError(error.message)
			}
		})
	}

	return { total, awaitingApproval, approved, rejected, delivered, closed, confirmed, deleted }
})

export const updateTransaction = createAsyncThunk('IMSTransactions/updateTransaction', async (data, { dispatch, getState }) => {
	// console.log(data)
	const response = await axios
		.post(`${process.env.REACT_APP_SUPABASE_EDGE_URL}/transactions/update-transaction`, data)
		.then((res) => {
			if (typeof res.data === 'object' && ('message' in res.data || 'error' in res.data)) {
				if ('error' in res.data) {
					throw res.data.error
				} else {
					throw res.data
				}
			}
			handleSuccess()
			return res
		})
		.catch((err) => {
			if (err) {
				handleError(err.message)
			}
			return err
		})
	console.log(response)
	// console.log(response.data)
	await dispatch(getTransactions(data.id))
	return response.data
})

export const addTransaction = createAsyncThunk('IMSTransactions/addTransaction', async (transaction, { dispatch, getState }) => {
	// await axios.post('/apps/transactions/add-transaction', transaction)
	const response = await axios
		.post(`${process.env.REACT_APP_SUPABASE_EDGE_URL}/transactions/create-transaction`, transaction)
		.then((res) => {
			if (typeof res.data === 'object' && ('message' in res.data || 'error' in res.data)) {
				if ('error' in res.data) {
					throw res.data.error
				} else {
					throw res.data
				}
			}
			handleSuccess()
			return res
		})
		.catch((err) => {
			if (err) {
				handleError(err.message)
			}
			return err
		})
	await dispatch(getTransactions(getState().transactions.params))
	// await dispatch(getAllTransaction())
	return response.data
})

export const deleteTransaction = createAsyncThunk('IMSTransactions/deleteTransaction', async (id, { dispatch, getState }) => {
	await axios
		.delete(`${process.env.REACT_APP_SUPABASE_EDGE_URL}/transactions/delete-transaction`, { data })
		.then((res) => {
			if (typeof res.data === 'object' && ('message' in res.data || 'error' in res.data)) {
				if ('error' in res.data) {
					throw res.data.error
				} else {
					throw res.data
				}
			}
			handleSuccess()
			return res
		})
		.catch((err) => {
			if (err) {
				handleError(err.message)
			}
			return err
		})
	await dispatch(getTransactions(getState().transactions.params))
	return data
})

export const IMSTransactionsSlice = createSlice({
	name: 'IMSTransactions',
	initialState: {
		data: [],
		counts: {
			total: 0,
			awaitingApproval: 0,
			approved: 0,
			rejected: 0,
			delivered: 0,
			confirmed: 0,
			closed: 0,
			deleted: 0
		},
		params: {},
		allTransactions: [],
		materials: {}
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getAllTransactions.fulfilled, (state, action) => {
				state.allTransactions = action.payload
			})
			.addCase(getTransactions.fulfilled, (state, action) => {
				state.data = action.payload.data
				state.params = action.payload.params
				state.totalPages = action.payload.totalPages
			})
			// .addCase(getTransactionDetails.fulfilled, (state, action) => {
			// 	state.data = action.payload
			// })
			.addCase(getSingleTransaction.fulfilled, (state, action) => {
				state.data = action.payload
			})
			.addCase(getTransactionCounts.fulfilled, (state, action) => {
				state.counts.total = action.payload.total
				state.counts.awaitingApproval = action.payload.awaitingApproval
				state.counts.approved = action.payload.approved
				state.counts.rejected = action.payload.rejected
				state.counts.delivered = action.payload.delivered
				state.counts.confirmed = action.payload.confirmed
				state.counts.closed = action.payload.closed
				state.counts.deleted = action.payload.deleted
			})
			.addCase(setMaterialDetails.fulfilled, (state, action) => {
				state.materials[action.payload.id] = action.payload
			})
	}
})

export default IMSTransactionsSlice.reducer
